import { instance } from "apis/interceptor";
import * as Sentry from "@sentry/react";
import { TVisitor, VISIT_STATUS } from "./type";

type ResponseType<T> = {
    success: boolean;
    statusCode?: number;
    message?: string;
    data?: T;
};

//INFO: (new) 방문자별 방문정보 수정 및 안내메시지 재전송
export const reSendGuideMessage = async (visitor: TVisitor): Promise<ResponseType<TVisitor>> => {
    try {
        const res = await instance.patch("/visitors/visitor/resend-guide-message", visitor);
        return { success: true, data: res.data };
    } catch (error: any) {
        Sentry.captureException(error, { extra: visitor });
        const status = error.response?.status;
        if (status === 423) {
            return { success: false, message: "접근 권한이 없습니다." };
        } else {
            return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
        }
    }
};

//INFO: (new) 방문자별 개별 방문 상태 변경하기
export const changeVisitorStatus = async (visitRecordId: string, visitorId: string, visitorStatus: VISIT_STATUS): Promise<ResponseType<boolean>> => {
    try {
        const res = await instance.patch("/visitors/visitor/status/individual", {
            visitRecordId: visitRecordId,
            visitorId: visitorId,
            visitorStatus: visitorStatus,
        });

        return { success: res.data.result };
    } catch (error) {
        Sentry.captureException(error, { extra: { visitRecordId: visitRecordId, visitorId: visitorId, visitorStatus: visitorStatus } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
};

//INFO: (new) 방문자 상태 일괄로 방문 완료로 변경하기
export const changeBulkVisitorState = async (visitRecordId: string): Promise<ResponseType<boolean>> => {
    try {
        const res = await instance.patch("/visitors/visitor/status/bulk", {
            id: visitRecordId,
        });

        return { success: res.data.result };
    } catch (error) {
        Sentry.captureException(error, { extra: { id: visitRecordId } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
};
